<template>
    <div id="amod" :class="{hover}" @click.stop="onClick">
        <!-- <div class="card shd"></div> -->
        <div class="card cardb">
            <AddTag :on="tag" @ck="onTag" v-if="!notag"></AddTag>
            <div class="wd">{{info.ChineseDefinition}}</div>
        </div>
        <div class="card carda">
            <AddTag :on="tag" @ck="onTag" v-if="!notag"></AddTag>
            <div>
                <div class="wd">{{info.Text}}</div>
                <div class="icon">
                    <img src="@/assets/img/sound-default.svg" @click.stop="play">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AddTag from '@/components/AddTag'
import mainDelegate from '@/delegate/mainDelegate'
export default {
    mixins: [mainDelegate],
    props: ['info', 'tag', 'notag', 'exercisex'],
    data() {
        return {
            hover: false,
            disableClick: false
        }
    },
    components: {
        AddTag
    },
    methods: {
        onClick() {
            if (this.disableClick) return
            this.disableClick = true
            this.wait()
            this.hover = !this.hover
            // this.hover && this.exercisex++
            this.hover && this.$emit('update:exercisex', this.exercisex + 1)
            this.$emit('hover', this.hover)
        },
        play() {
            this.wordSound.autoPlay(this.info.AudioFileName)
        },
        onTag() {
            if (this.tag) return //禁止取消tag
            this.$emit('tag', {
                Id: this.info.Id,
                tag: this.tag ? 'remove' : 'add'
            })
        },
        wait() {
            setTimeout(_ => (this.disableClick = false), 1000)
        }
    },
    watch: {
        info() {
            this.hover = false
            this.$emit('update:exercisex', 0)
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@card-hight: 146px;
#amod {
    text-align: center;
    position: relative;
    // width: auto;
    width: 300px;
    height: @card-hight;
    // margin: 12px;
    margin: 12px auto;
    perspective: 1000;
    cursor: pointer;
    .card {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: @card-hight;
        border: 2px solid @main-color;
        border-radius: 10px;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: transform 1s;
        transform-style: preserve-3d;
        transform-origin: center;
        .wd {
            font-size: 30px;
            color: @main-color;
        }
    }
    .shd {
        border: none;
        filter: blur(2px);
        transition: transform 1s;
        transform: translate(5px, 5px) rotateY(0deg);
        background: #eeeeee;
    }
    .carda {
        transform: rotateY(0deg);
        backface-visibility: hidden;
        // transition-timing-function: ease-in-out;
        .icon {
            margin-top: 11px;
            &:active {
                filter: brightness(80%);
            }
        }
    }
    .cardb {
        transform: rotateY(-180deg);
        backface-visibility: hidden;
        // transition-timing-function: ease-in-out;
    }
    &.hover {
        .carda {
            transform: rotateY(180deg);
        }
        .cardb {
            transform: rotateY(0deg);
        }
        .shd {
            transform: translate(10px, 10px) rotateY(180deg);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TurnCard.vue